import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {SurfaceState} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/SurfaceState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {CustomDropdown} from '@mintdata-wsp/wsp/ui/components/customDropdown/CustomDropdown';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./PagesDropdown.less');
const cx = classnames.bind(styles);

@observer
export class PagesDropdown extends React.Component<any, any>
{
    @bind
    private _handleClick(event:React.MouseEvent<HTMLDivElement>):void
    {
        event.stopPropagation();
    }

    @bind
    private _getListItemClickHandler(page:Page, closePopoverFunc:()=>void):(event:React.MouseEvent<any>) => void
    {
        return (event:React.MouseEvent<any>):any => {
            closePopoverFunc();
            controllers.ui.surfaceArea.setActivePage(page);
        };
    }

    @bind
    private _renderPagesList(closePopoverFunc:()=>void):JSX.Element
    {
        const {surfaceArea} = controllers.ui;
        const surfaceState:SurfaceState = surfaceArea.getState();

        return (
            <ul className={cx('list')}>
                {surfaceState.pagesItemsOrdered.map((page:Page) => (
                    <li
                        className={cx('listItem')}
                        onClick={this._getListItemClickHandler(page, closePopoverFunc)}
                        key={page.id}
                    >
                        <span className={cx('iconWrapper')}>
                            {page.id === surfaceState.activePage.id && <MDIcon
                                className={cx('icon')}
                                name={MDIcons.common.Checkmark}
                                size={MDIconSize.medium16}
                            />}
                        </span>
                        <span className={cx('title')}>{page.name}</span>
                    </li>
                ))}
            </ul>
        );
    }

    render():JSX.Element | false | null
    {
        const {surfaceArea} = controllers.ui;

        const surfaceState:SurfaceState = surfaceArea.getState();
        const activePage:Page = surfaceState && surfaceState.activePage;

        if( !activePage )
            return null;

        return <CustomDropdown
            title={activePage.name}
            renderListFunc={this._renderPagesList}
            onDoubleClick={this._handleClick}
            onClick={this._handleClick}
        />;
    }
}
